import { Component, OnInit } from '@angular/core';
import { CompanyInfoStateService } from '../../modules/contact/services/company-info-state.service';

@Component({
  selector: 'app-page-privacy',
  templateUrl: './page-privacy.component.html',
  styleUrls: ['./page-privacy.component.css']
})
export class PagePrivacyComponent implements OnInit {

  constructor(
    private companyInfoStateService: CompanyInfoStateService
  ) { }

  ngOnInit(): void {
    this.companyInfoStateService.initialize().subscribe();
    this.companyInfoStateService.initializeTodayWorkingHours().subscribe();
  }

  get phone(): string {
    return this.companyInfoStateService.companyInfo ? this.companyInfoStateService.companyInfo.phone : '';
  }

  get street(): string {
    return this.companyInfoStateService.companyInfo ? this.companyInfoStateService.companyInfo.street : '';
  }

  get city(): string {
    return this.companyInfoStateService.companyInfo ? this.companyInfoStateService.companyInfo.city : '';
  }

  get zip(): string {
    return this.companyInfoStateService.companyInfo ? this.companyInfoStateService.companyInfo.zip + '' : '';
  }

  get name(): string {
    return this.companyInfoStateService.companyInfo ? this.companyInfoStateService.companyInfo.name : '';
  }

  get website(): string {
    return this.companyInfoStateService.companyInfo ? this.companyInfoStateService.companyInfo.website : '';
  }

  get email(): string {
    return this.companyInfoStateService.companyInfo ? this.companyInfoStateService.companyInfo.email : '';
  }

}
